export const recipientAppConstants = {
    // Add and editing app
    SAVING_RECIPIENT_APP_REQUEST: 'SAVING_RECIPIENT_APP_REQUEST',
    SAVING_RECIPIENT_APP_SUCCESS: 'SAVING_RECIPIENT_APP_SUCCESS',
    SAVING_RECIPIENT_APP_FAILURE: 'SAVING_RECIPIENT_APP_FAILURE',

    // Loading apps
    LOAD_RECIPIENT_APPS_REQUEST: 'LOAD_RECIPIENT_APPS_REQUEST',
    LOAD_RECIPIENT_APPS_SUCCESS: 'LOAD_RECIPIENT_APPS_SUCCESS',
    LOAD_RECIPIENT_APPS_FAILURE: 'LOAD_RECIPIENT_APPS_FAILURE',

    // Delete app
    DELETE_RECIPIENT_APP_REQUEST: 'DELETE_RECIPIENT_APP_REQUEST',
    DELETE_RECIPIENT_APP_SUCCESS: 'DELETE_RECIPIENT_APP_SUCCESS',
    DELETE_RECIPIENT_APP_FAILURE: 'DELETE_RECIPIENT_APP_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/recipientApp.constants.js